import React, { Component } from "react";
import {
  HashRouter,
  Route,
  Switch,
  Redirect
} from "react-router-dom";

import "./App.scss";
import "antd/dist/antd.css";

const loading = () => (
  <div className="animated fadeIn pt-3 text-center">
    Loading...
  </div>
);

const DefaultLayout = React.lazy(() =>
  import("./containers/DefaultLayout")
);

const Login = React.lazy(() =>
  import("./views/Pages/Login")
);

const Register = React.lazy(() =>
  import("./views/Pages/Register")
);

const Page404 = React.lazy(() =>
  import("./views/Pages/Page404")
);

const Page500 = React.lazy(() =>
  import("./views/Pages/Page500")
);

const PatientTokenBooking = React.lazy(() =>
  import("./views/PatientTokenBooking/PatientTokenBooking")
);

const TokenTV = React.lazy(() =>
  import("./views/TokenTV/TokenTV")
);

const PatientTokenStatus = React.lazy(() =>
  import("./views/PatientTokenStatus/PatientTokenStatus")
);

class App extends Component {
  render() {
    const role = localStorage.getItem("Role");

    return (
      <HashRouter>
        <React.Suspense fallback={loading()}>
          <Switch>

            {/* LOGIN */}
            <Route
              exact
              path="/login"
              render={(props) =>
                role ? (
                  // <Redirect to="/dashboard" />

                  <Route
  path="/"
  render={() => {
    const role = (localStorage.getItem("Role") || "").toUpperCase();

    if (!role) return <Redirect to="/login" />;

    switch (role) {
      case "DOCTOR":
        return <Redirect to="/TodaysPatient" />;

      case "NURSE":
        return <Redirect to="/todays-visit" />;

      case "BILLING":
        return <Redirect to="/VisitList" />;

      case "ADMIN":
        return <Redirect to="/PatientManagement" />;

      default:
        return <Redirect to="/login" />;
    }
  }}
/>

                ) : (
                  <Login {...props} />
                )
              }
            />

            {/* REGISTER */}
            <Route
              exact
              path="/register"
              component={Register}
            />

            {/* ERROR */}
            <Route
              exact
              path="/404"
              component={Page404}
            />

            <Route
              exact
              path="/500"
              component={Page500}
            />

            <Route
              exact
              path="/PatientTokenBooking"
              component={PatientTokenBooking}
            />

            <Route
              exact
              path="/PatientTokenStatus"
              component={PatientTokenStatus}
            />

            <Route
              exact
              path="/TokenTV"
              component={TokenTV}
            />

            {/* PROTECTED ROUTES */}
            <Route
              path="/"
              render={(props) =>
                role ? (
                  <DefaultLayout {...props} />
                ) : (
                  <Redirect to="/login" />
                )
              }
            />
          </Switch>
        </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;